var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { DateConverter } from "./../../../converters/DateConverter";
export class AntiMoneyLaundering {
  constructor(_data) {
    /**
     */
    __publicField(this, "DocumentReference");
    /**
     */
    __publicField(this, "ReceivedAt");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof AntiMoneyLaundering
     */
    __publicField(this, "$type", "V1.Companies.AntiMoneyLaundering");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    if (_data) {
      this.DocumentReference = _data["DocumentReference"];
      this.ReceivedAt = DateConverter.from(_data["ReceivedAt"]);
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    _data["DocumentReference"] = this.DocumentReference;
    _data["ReceivedAt"] = DateConverter.toUtcDateString(this.ReceivedAt);
    return _data;
  }
}
